import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Typography, Link } from '@mui/material';
import SectionTitle from '../../../components/SectionTitle';
import CareersForm from '../../../components/forms/CareersForm';

const GeyserClaimsFile = '/aboutUs/Geyser-claims-negotiator-Reception-2025.pdf';
const SeniorUnderwriterFile = '/aboutUs/Senior-underwriter-2025.pdf';

const CareersRoot = styled('div')(({ theme }) => ({
    padding: '50px 0',
}));

const CareersDesc = styled(Typography)(({ theme }) => ({
    fontStyle: 'italic',
}));

const CareerList = styled('ul')(({ theme }) => ({
    margin: 0,
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));

const CareerPoint = styled('li')(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));


const Careers = () => {
    return (
        <CareersRoot>
            <Container maxWidth="lg">
                <SectionTitle
                    title="Join Our Team"
                    subtitle="Current positions available"
                    align="left"
                />
                <CareerList>
                    <CareerPoint>
                        <Link 
                            href={SeniorUnderwriterFile} 
                            target="_blank" 
                            rel="noopener"
                            underline="hover"
                        >
                            Senior Underwriter
                        </Link>
                    </CareerPoint>
                </CareerList>
                <CareersDesc variant="body1">
                    Feel free to submit your details for future positions
                </CareersDesc>
                <CareersForm />
            </Container>
        </CareersRoot>
    );
};

export default Careers;
